/**
 * AutoMazen Interactive Tiles
 * 
 * JavaScript for handling mobile interactions with the interactive tiles.
 * On mobile devices, tiles will reveal their content on click rather than hover.
 */

(function() {
  // Wait for DOM to be fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Get all interactive tiles
    const tiles = document.querySelectorAll('.automazen-interactive-tiles__tile');
    
    // Skip if no tiles are found
    if (!tiles.length) return;
    
    // Only apply click handlers on mobile devices
    const isMobile = window.innerWidth < 768;
    
    if (isMobile) {
      // Add click event listeners to each tile
      tiles.forEach(tile => {
        tile.addEventListener('click', function(e) {
          // Check if we're clicking on a link - if so, let the link work
          const isLink = e.target.tagName === 'A' || 
                         e.target.closest('a.automazen-interactive-tiles__button');
          
          if (isLink) {
            // Don't prevent default - let the link navigate
            return;
          }
          
          // Prevent any default behavior
          e.preventDefault();
          
          // Toggle active state for this tile
          this.classList.toggle('active');
          
          // Close other tiles
          tiles.forEach(otherTile => {
            if (otherTile !== tile) {
              otherTile.classList.remove('active');
            }
          });
        });
      });
      
      // Close active tile when clicking outside
      document.addEventListener('click', function(e) {
        if (!e.target.closest('.automazen-interactive-tiles__tile')) {
          tiles.forEach(tile => {
            tile.classList.remove('active');
          });
        }
      });
    }
    
    // Handle resize events to adapt between mobile and desktop
    window.addEventListener('resize', function() {
      const currentIsMobile = window.innerWidth < 768;
      
      // If view changed between mobile and desktop
      if (currentIsMobile !== isMobile) {
        // Reload the page to reset all interactions
        // This is a simple approach - a more complex one would dynamically adjust
        location.reload();
      }
    });
  });
})();
